module.exports = __webpack_public_path__ + "static/media/kanban.b152969a.svg";